export enum DocumentContentStatus {
    Ok,
    NoFileContent,
    PdfError,
    Unknown
}